import { EstadoLiberarVentaENUM, useTableColumnsSolicitudLiberacion, useTableFilter, useTableServerSideFiltering } from "@/shared";
import { useGetFetchSupervisionLiberacionProspecto } from "@/shared/actions/erp/supervision.action";
import { GeneralTable } from "@/shared/components/ui";
import { IDataSolicitudFallido } from "@/shared/interfaces/erp/supervision/supervision.interface";
import { Grid } from "@mui/material";

type TableGeneralLiberacionProspectoProps = {
  estado_solicitud: EstadoLiberarVentaENUM;
}

const TableGeneralLiberacionProspecto = ({ estado_solicitud }: TableGeneralLiberacionProspectoProps) => {

  const { columnBaseLiberacionProspecto } = useTableColumnsSolicitudLiberacion({
    estado_solicitud: estado_solicitud
  });

  const {
    pagination,
    setPagination
  } = useTableFilter();

  const { filterObject, columnFilters, setColumnFilters } =
    useTableServerSideFiltering();

  const { pageIndex, pageSize } = pagination;

  const { isLoading, data: supervicionRes,
    isRefetching, } = useGetFetchSupervisionLiberacionProspecto(
      {
        page: pageIndex + 1,
        page_size: pageSize,
        estado_solicitud: estado_solicitud,
        ...filterObject,
        filterByState: false
      }
    );


  return (
    <>
      <Grid container spacing={2}>
        <Grid item xs={12}>

        </Grid>
        <Grid item xs={12}>
          <GeneralTable<IDataSolicitudFallido>
            columns={columnBaseLiberacionProspecto}
            data={supervicionRes?.data.data || []}
            //
            isLoading={isLoading}
            isRefetching={isRefetching}
            // // search
            enableGlobalFilter={false}
            // onGlobalFilterChange={setGlobalFilter}
            // // pagination
            pagination={pagination}
            onPaging={setPagination}
            rowCount={supervicionRes?.data?.count}

            ///* filters - server side
            enableColumnActions={true}
            enableManualFiltering={true}
            columnFilters={columnFilters}
            onColumnFiltersChange={setColumnFilters}

            // // actions
            actionsColumnSize={120}
            // crud
            positionActionsColumn='first'
            enableEditing={false}

          />
        </Grid>
      </Grid>

    </>

  );
}


export default TableGeneralLiberacionProspecto;